module.exports = __webpack_public_path__ + "static/media/54.b970562e.jpg";